import _ from 'underscore';
/**
 * Update schema to add CampaignType property that is used in waterfall filter for new UI
 *
 * @param {Object} entitySchema - the option to update the filter
 * @param {string} property - optional param to set field name of campaignType property
 * @param {array} campaignTypeNotSupported - specific unsupported campaign types in each filter.
 * @returns {void}
*/
export function addCampaignTypePropertyForFilter({
  entitySchema, property = 'Campaign/CampaignType', permissions, campaignTypeNotSupported,
}) {
  const isHotelCampaignEnabled = _.chain(permissions).result('dynamic').result('HotelCampaign').value();
  const isPerformanceMaxEnabled = _.chain(permissions).result('dynamic').result('PerformanceMaxCampaigns').value();
  const isLinkedInCampaignEnabled = _.chain(permissions).result('dynamic').result('LinkedInCampaigns').value();
  const IsRenameHotelToLodgingEnabled = _.chain(permissions).result('dynamic').result('IsRenameHotelToLodgingEnabled').value();
  const toExtended = {
    CampaignType: {
      filterable: true,
      name: 'CampaignType',
      originalProperty: 'CampaignType',
      property,
      type: 'string',
      enumType: 'CampaignType',
      enum: _.difference(_.compact([
        "Enum.CampaignType'Default'",
        "Enum.CampaignType'Shopping'",
        "Enum.CampaignType'Audience'",
        "Enum.CampaignType'Smart'",
        isHotelCampaignEnabled && "Enum.CampaignType'Hotel'",
        isPerformanceMaxEnabled && "Enum.CampaignType'PerformanceMax'",
        isLinkedInCampaignEnabled && "Enum.CampaignType'LinkedIn'",
      ]), campaignTypeNotSupported),
      enumValueMap: _.omit({
        "Enum.CampaignType'Default'": 'Default',
        "Enum.CampaignType'Shopping'": 'Shopping',
        "Enum.CampaignType'Audience'": 'Audience',
        "Enum.CampaignType'Smart'": 'Smart',
        ...isHotelCampaignEnabled ? { "Enum.CampaignType'Hotel'": IsRenameHotelToLodgingEnabled ? 'Lodging' : 'Hotel' } : {},
        ...isPerformanceMaxEnabled ? { "Enum.CampaignType'PerformanceMax'": 'PerformanceMax' } : {},
        ...isLinkedInCampaignEnabled ? { "Enum.CampaignType'LinkedIn'": 'LinkedIn' } : {},
      }, campaignTypeNotSupported),
      chooseType: 'checkbox',
      alias: {
        legacy: 'CampaignCampaignType',
      },
    },
  };
  _.extend(entitySchema.properties, toExtended);
}

